import { render } from "./QueryBuilderComponent.vue?vue&type=template&id=275cc5ba&scoped=true&ts=true"
import script from "./QueryBuilderComponent.vue?vue&type=script&lang=ts"
export * from "./QueryBuilderComponent.vue?vue&type=script&lang=ts"

import "./QueryBuilderComponent.vue?vue&type=style&index=0&id=275cc5ba&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275cc5ba"]])

export default __exports__